import React, { useDebugValue, useEffect, useState } from "react";

import {
  ButtonVisibility,
  CONNECTION_REQUEST_STATUS,
  CONNECTION_STATUS,
  GENDER,
  GENDERDECODE,
  GENDERDECODELOOKING,
  LOCAL_STORAGE,
  MEETING_PURPOSE_ORDER,
  REPORT_TYPES,
} from "../../../utils/constants";
import RightSideDrawer from "../../../components/rightDrawer";
import { useNavigate } from "react-router-dom";
import {
  getConnectionButtonVisibilityState,
  getDayOfWeek,
  getMonthAndDay,
  getTime,
} from "../../../utils/common";
import { getLocalStorage } from "../../../utils/localStorage";
import { ConnectionButtonVisibilityState } from "../../../utils/Interfaces";
import { useSpinner } from "../../../components/spinner/SpinnerContext";
import { eventDetailService } from "../../../services/eventDetailServices";
import { toast } from "react-toastify";
import Modal from "../../../components/modal";
import AppStore from "../../../assets/theme/images/appStore.png";
import PlayStore from "../../../assets/theme/images/playStore.png";
import MenuIcon from "../../../assets/Icons/header/menu.svg";
import Menu from "../../../components/Menu";
import SearchSelect from "../../../components/search";
import ConnectionButton from "../../../components/ConnectionButton";
import ConnectionRequestSentWidget from "../../../components/CustomComponents/ConnectionRequest/Sent";
import ConnectionRequestMatchedWidget from "../../../components/CustomComponents/ConnectionRequest/Matched";
import Icons from "../../../assets/theme/icons";
import Tick from "../../../assets/Icons/Analytics/greenTick.svg";
import Cross from "../../../assets/Icons/Analytics/cross.svg";
import NextActiveIcon from "../../../assets/theme/images/next-icon-active.png";
import NextDisableIcon from "../../../assets/theme/images/next-icon.png";
import { Mars, NonBinary, Venus } from "lucide-react";
import GuestAnswersView from "../../../components/GuestAnswersView";

interface UserProfileProps {
  eventId?: number | undefined;
  loggedUserId?: any;
  selectedUserId?: any;
  requestType?: string;
  hostId?: any;
  userObj?: any;
  eventDetailObj?: any;
  isHost?: boolean;
}

const UserProfile: React.FC<UserProfileProps> = ({
  eventId,
  loggedUserId,
  selectedUserId,
  userObj,
  hostId,
  eventDetailObj,
  isHost = false,
}) => {
  const userId: any = getLocalStorage(LOCAL_STORAGE.USER_ID);
  const [userDetails, setUserDetails] = useState<any>("");
  const [selectedDrawer, setSelectedDrawer] = useState("");

  const [isConnectionModalOpen, setIsConnectionModalOpen] = useState(false);
  const [connectionExpanded, setConnectionExpanded] = useState(false);
  const [guestDetails, setGuestDetails] = useState<any>();
  const [isGuestSame, setIsGuestSame] = useState(false);
  const [reqGuestId, setReqGuestId] = useState<number | null>(null);
  const [requestedConnectionStatus, setRequestedConnectionStatus] =
    useState("");
  const [reportType, setReportType] = useState("");
  const [reportDescription, setReportDescription] = useState("");
  const [connectionVisibility, setConnectionVisibility] =
    useState<ConnectionButtonVisibilityState>({
      datingButtonVisibility: ButtonVisibility.Hidden,
      friendshipButtonVisibility: ButtonVisibility.Hidden,
      openToAnyButtonVisibility: ButtonVisibility.Hidden,
    });
  const navigate = useNavigate();
  const { setShowSpinner } = useSpinner();

  const [isUnmatchMenuOpen, setIsUnmatchMenuOpen] = useState(false);
  const [isChatModalOpen, setIsChatModalOpen] = useState(false);
  const [isUnmatchModalOpen, setIsUnmatchModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [showMatchedButton, setShowMatchedButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selfUserDetails, setSelfUserDetails] = useState<any>();
  const [anonymousStatus, setAnonymousStatus] = useState<boolean>(false);
  const [isVisitedByHost, setIsVisitedByHost] = useState<boolean>(isHost);

  // Setter for Connection Request / Modal
  const [connectionRequestStatus, setConnectionRequestStatus] =
    useState<boolean>(false);
  const [connectionMatchedStatus, setConnectionMatchedStatus] =
    useState<boolean>(false);
  const [connectionReqLoader, setConnectionReqLoader] =
    useState<boolean>(false);

  const [connectedMessage, setConnectedMessage] = useState("");
  const [connectionActionMessage, setConnectionActionMessage] = useState("");
  // const [connectionActionMessage , setConnectionActionMessage] = useState("");

  const [topBarInfoMessages, setTopBarInfoMessages] = useState<any>(null);
  const [connectedStatus, setConnectedStatus] = useState<boolean>(false);

  // User Photo Slider
  const [activePhotoSlider, setActivePhotoSlider] = useState<number>(0);
  const [userProfilePhotos, setUserProfilePhotos] = useState<number>(1);
  const [profileVisibility, setProfileVisibility] = useState({
    genderVisibility: false,
    informationVisible: false,
    heightVisibility: false,
    lookingForVisibility: false,
    meetingPurposeVisibility: false,
    interestVisibility: false,
  });

  useEffect(() => {
    if (selectedUserId) {
      setTopBarInfoMessages(null);
      fetchGuestDetails(selectedUserId);
      setReqGuestId(selectedUserId);
    }
  }, [selectedUserId]);

  // useEffect(() => {
  //   setIsVisitedByHost(isHost);
  // }, [isHost]);

  const [disableOriginalProfile, setDisableOriginalProfile] = useState(0);
  useEffect(() => {
    if (userObj?.userId == hostId && userObj?.hostAlias.length > 0) {
      setDisableOriginalProfile(hostId);
    } else {
      setDisableOriginalProfile(0);
    }
  }, [userObj, reqGuestId, hostId]);

  function getMutualConnectionStatus(status1: string, status2: string): string {
    const s1 = status1.trim();
    const s2 = status2.trim();

    if (s1 === "Heart" && s2 === "Heart") {
      return "dating";
    }
    if (s1 === "Handshake" && s2 === "Handshake") {
      return "friendship";
    }
    if (s1 === "Open" && s2 === "Open") {
      return "open to both";
    }
    if (
      (s1 === "Handshake" && s2 === "Open") ||
      (s1 === "Open" && s2 === "Handshake")
    ) {
      return "friendship";
    }
    if (
      (s1 === "Heart" && s2 === "Open") ||
      (s1 === "Open" && s2 === "Heart")
    ) {
      return "dating";
    }

    return "";
  }

  const fetchGuestDetails = async (
    reqUserId: number,
    infoMessageClear: boolean = false
  ) => {
    try {
      setLoading(true);
      setConnectionExpanded(false);
      // if(infoMessageClear) {
      //   setTopBarInfoMessages(null);
      // }

      setConnectedStatus(false);
      setActivePhotoSlider(0);

      const res = await eventDetailService.getGuestDetails({
        userId,
        req_user_id: reqUserId,
      });

      if (!res?.data) {
        throw new Error("No data received from server");
      }

      const { current_user, secondary_user, match_status } = res.data;

      // Set guest details
      setGuestDetails(current_user?.userProfileResponse);
      setSelfUserDetails(current_user?.userProfileResponse);
      setIsGuestSame(Number(userId) === Number(reqUserId));

      // Set Userb Data visibility check
      const isLoggedInUser =
        Number(userId) === Number(reqUserId) || isVisitedByHost;
      const userProfileData = current_user?.userProfileResponse;
      setProfileVisibility({
        genderVisibility:
          isLoggedInUser || userProfileData?.genderVisibility || false,
        informationVisible:
          isLoggedInUser || userProfileData?.information_visible || false,
        heightVisibility:
          isLoggedInUser || userProfileData?.heightVisibility || false,
        lookingForVisibility:
          isLoggedInUser || userProfileData?.lookingForVisibility || false,
        meetingPurposeVisibility:
          isLoggedInUser || userProfileData?.meetingPurposeVisibility || false,
        interestVisibility:
          isLoggedInUser || userProfileData?.interestVisibility || false,
      });

      
      setUserProfilePhotos(
        current_user?.userProfileResponse?.userPhotos?.length
      );

      // Handle connection visibility and status
      let visibilityStateCheck = getConnectionButtonVisibilityState(
        current_user,
        secondary_user
      );
      if (visibilityStateCheck === undefined) {
        const visibilityState: ConnectionButtonVisibilityState = {
          datingButtonVisibility: ButtonVisibility.Hidden,
          friendshipButtonVisibility: ButtonVisibility.Hidden,
          openToAnyButtonVisibility: ButtonVisibility.Hidden,
        };
        setConnectionVisibility(visibilityState);
        // toast.error("This user does not match your criteria");
        // setConnectedMessage("This user does not match your criteria");

        setConnectedStatus(false);
        if (
          Number(userId) != Number(reqUserId) &&
          !(userObj?.userId == hostId && userObj?.hostAlias.length > 0)
        ) {
          setTopBarInfoMessages({
            status: "error",
            message: `${current_user?.userProfileResponse?.firstName} does not fit your connection preferences.`,
          });
        }
      } else {
        setConnectionVisibility(visibilityStateCheck);
      }

      // Handle match status
      if (match_status?.status === "Matched") {
        const matchedDate = current_user?.userProfileResponse?.matchDate;

        setConnectionVisibility({
          datingButtonVisibility: ButtonVisibility.Hidden,
          friendshipButtonVisibility: ButtonVisibility.Hidden,
          openToAnyButtonVisibility: ButtonVisibility.Hidden,
        });

        setShowMatchedButton(true);

        if (reqGuestId) {
          await matchUserInCometChat(userId, reqGuestId);
        }

        // toast.success(
        //   `Connected on ${getMonthAndDay(matchedDate)} ${getDayOfWeek(
        //     matchedDate
        //   )} ${getTime(matchedDate)}`
        // );
        const mutualStatus = getMutualConnectionStatus(
          match_status?.sender_response_status,
          match_status?.receiver_response_status
        );
        setConnectedStatus(true);
        setTopBarInfoMessages({
          status: "success",
          message: `Connected${
            mutualStatus && mutualStatus.length > 0
              ? ` for '${mutualStatus.toLowerCase()}'` // wrap in apostrophes
              : ""
          }.`,
        });
      }

      // Set requested connection status
      const isCurrentUserSender = match_status?.sender_user_id == userId;
      setRequestedConnectionStatus(
        isCurrentUserSender
          ? match_status?.sender_response_status
          : match_status?.receiver_response_status
      );
      setLoading(false);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.error || error?.message;
      toast.error("Failed to fetch guest details");
      console.error("Error in fetchGuestDetails:", errorMessage);
    }
  };

  // create function
  const handleConnectionRequest = async (status: string) => {
    const payload = {
      senderUserId: parseInt(userId),
      receiverUserId: reqGuestId,
      eventId: eventId,
      response_status: status,
      isAnonymous: anonymousStatus,
    };
    try {
      setConnectionReqLoader(true);
      const res = await eventDetailService.likeEventUserProfile(payload);
      if (res?.data) {
        // setRequestedConnectionStatus(status);
        let connectionActionMsg = "";
        let guestName = `${guestDetails?.firstName}`;
        if (status != CONNECTION_STATUS.UNMATCH) {
          if (res?.data?.isProfileMatched) {
            connectionActionMsg = `You are now connected with ${guestName}!`;
            // toast.success(connectionActionMsg);
            // setConnectionMatchedStatus(true);
            // setSelectedDrawer(CONNECTION_REQUEST_STATUS.REQUEST_MATCHED);
            setTopBarInfoMessages({
              status: "success",
              message: connectionActionMsg,
            });
          } else {
            connectionActionMsg = `You liked ${guestName}'s profile ${
              anonymousStatus ? "anonymously" : "non-anonymously"
            }!`;
            // toast.success(connectionActionMsg);
            // setConnectionRequestStatus(true);
            // setSelectedDrawer(CONNECTION_REQUEST_STATUS.REQUEST_SENT);
            setTopBarInfoMessages({
              status: "success",
              message: connectionActionMsg,
            });
          }
          if (reqGuestId) {
            fetchGuestDetails(reqGuestId);
          }
          setConnectionReqLoader(false);
          setTopBarInfoMessages({
            status: "success",
            message: connectionActionMsg,
          });
        } else {
          setConnectionReqLoader(false);
          // toast.success(res?.data?.message);

          if (reqGuestId) {
            fetchGuestDetails(reqGuestId);
          }
          setTopBarInfoMessages({
            status: "success",
            message: res?.data?.message,
          });
        }
      }
    } catch (error: any) {
      setConnectionReqLoader(false);
      console.log(
        "error in handleConnectionRequest : ",
        error?.response?.data?.error || error?.message
      );
    }
  };

  const unmatchUser = async () => {
    try {
      const payload = {
        senderUserId: parseInt(userId),
        receiverUserId: reqGuestId,
        eventId: eventId,
        response_status: CONNECTION_STATUS.UNMATCH,
        isAnonymous: false,
      };
      const res = await eventDetailService.likeEventUserProfile(payload);
      if (res?.data) {
        let statusInfo = "success";
        let connectionActionMsg = "";
        let guestName = `${guestDetails?.firstName}`;
        if (res?.data?.isProfileMatched && res?.data?.isProfileLiked) {
          connectionActionMsg = `You are now connected with ${guestName}!`;
        } else if (!res?.data?.isProfileLiked && !res?.data?.isProfileMatched) {
          connectionActionMsg = `You have unliked ${guestName} profile.!`;
          statusInfo = "warning";
        } else if (res?.data?.isProfileLiked && !res?.data?.isProfileMatched) {
          connectionActionMsg = `You liked ${guestName}'s profile!`;
        }
        setTopBarInfoMessages({
          status: statusInfo,
          message: connectionActionMsg,
        });
        // toast.success(res?.data?.message);
        if (reqGuestId) {
          unMatchUserInCometChat(userId, reqGuestId);
          deleteConversationFromCometChat(userId, reqGuestId.toString());
          setShowMatchedButton(false);
          fetchGuestDetails(reqGuestId);
          setIsConnectionModalOpen(false);
        }
      }
    } catch (error: any) {
      console.log(
        "error unmatchUser : ",
        error?.response?.data?.error || error?.message
      );
    }
  };

  const unMatchUserInCometChat = async (userId: number, friendId: number) => {
    try {
      const res = await eventDetailService.unMatchInCometChat(userId, friendId);
    } catch (error: any) {
      console.log(
        "error unMatchUserInCometChat : ",
        error?.response?.data?.error || error?.message
      );
    }
  };

  const deleteConversationFromCometChat = async (
    userId: number,
    friendId: string
  ) => {
    try {
      const res = await eventDetailService.deleteConversationFromCometChat(
        userId,
        friendId
      );
    } catch (error: any) {
      console.log(
        "error deleteConversationFromCometChat : ",
        error?.response?.data?.error || error?.message
      );
    }
  };

  const matchUserInCometChat = async (userId: number, friendId: number) => {
    try {
      const res = await eventDetailService.matchInCometChat(userId, friendId);
      if (res?.data) {
        toast.success(res?.data?.message);
      }
    } catch (error: any) {
      console.log(
        "error matchUserInCometChat : ",
        error?.response?.data?.error || error?.message
      );
    }
  };
  const reportUser = async () => {
    try {
      const payload = {
        reporteeUserId: reqGuestId,
        reason: reportType,
        comment: reportDescription,
      };
      const res = await eventDetailService.reportUser(payload);
      if (res?.data && reqGuestId) {
        setIsConnectionModalOpen(false);
        unMatchUserInCometChat(userId, reqGuestId);
        deleteConversationFromCometChat(userId, reqGuestId.toString());
        setShowMatchedButton(false);
        fetchGuestDetails(reqGuestId);
        toast.success(res?.data?.message);
      }
    } catch (error: any) {
      console.log(
        "error reportUser : ",
        error?.response?.data?.error || error?.message
      );
    }
  };

  const toggleConnectionExpanded = () => {
    setConnectionExpanded(!connectionExpanded);
  };

  const getGenderIcon1 = (genderInfo: string) => {
    return ["Man", "man", "Male", "Men"].includes(genderInfo) ? (
      <img src={Icons.MaleIcon} alt="male" className="w-6" />
    ) : (
      <img src={Icons.FemaleIcon} alt="female" className="w-6" />
    );
  };

  const getGenderColorStyles = (gender: string) => {
    if (["Man", "man", "Male", "Men"].includes(gender)) {
      return {
        bg: "#bda1ff",
        border: "#bda1ff",
        text: "#5E3BC1",
      };
    } else if (["Woman", "woman", "Female", "Women"].includes(gender)) {
      return {
        bg: "#feb89a",
        border: "#feb89a",
        text: "#C2410C",
      };
    } else {
      return {
        bg: "#fffaa2",
        border: "#fffaa2",
        text: "#855C00",
      };
    }
  };
  const getGenderIcon = (
    genderInfo: string,
    className = "w-6 h-6",
    strokeColor?: string
  ) => {
    const text = "#000000";
    if (["Man", "man", "Male", "Men"].includes(genderInfo)) {
      return (
        <Mars
          className={`${className}`}
          stroke={text}
          strokeWidth={2}
          // size={20}
        />
      );
    } else if (["Woman", "woman", "Female", "Women"].includes(genderInfo)) {
      return (
        <Venus
          className={`${className}`}
          stroke={text}
          strokeWidth={2}
          // size={20}
        />
      );
    } else {
      return (
        <NonBinary
          className={`${className}`}
          stroke={text}
          strokeWidth={2}
          // size={15}
        />
      );
    }
  };

  const handleRefetchGuestDetails = () => {
    setConnectionRequestStatus(false);
    setConnectionMatchedStatus(false);
    // setIsConnectionModalOpen(true)
    if (reqGuestId) {
      fetchGuestDetails(reqGuestId);
    }
  };

  type StatusType = "info" | "success" | "warning" | "error";
  const statusStyles: Record<
    StatusType,
    { bg: string; text: string; icon: any }
  > = {
    info: {
      bg: "bg-blue-100",
      text: "text-blue-800",
      icon: Tick,
    },
    success: {
      bg: "bg-green-100",
      text: "text-green-800",
      icon: Tick,
    },
    warning: {
      bg: "bg-yellow-100",
      text: "text-yellow-800",
      icon: Tick,
    },
    error: {
      bg: "bg-red-100",
      text: "text-red-800",
      icon: Cross,
    },
  };

  interface TopStatusBarProps {
    status: StatusType;
    message: string;
  }
  const TopStatusBar: React.FC<TopStatusBarProps> = ({ status, message }) => {
    const styles = statusStyles[status];

    return (
      <div
        className={`flex items-center px-3 py-3 ${styles.bg} ${styles.text} w-full  md:w-auto lg:w-auto shadow-sm rounded-xl border border-white`}
      >
        <div className="mr-2">
          <img src={styles.icon} />
        </div>
        <p className="text-xs md:text-[17px] font-medium">{message}</p>
      </div>
    );
  };
  const handleUserPhotoSlider = (sliderIndex: number) => {
    console.log("here slider imnage index", sliderIndex);
    setActivePhotoSlider(sliderIndex);
  };

  return (
    <>
      <div className="overflow-y-auto h-[89vh] md:h-[97vh] scrollableDiv overscroll-contain -webkit-overflow-scrolling-touch">
        <div className="w-full flex justify-between items-center  my-2 ">
          <div className="w-5/6 justify-end items-center">
            {connectedMessage}
          </div>
          {showMatchedButton && !isGuestSame && (
            <div className="w-1/6 justify-end items-center">
              <div
                className="w-full flex justify-end p-2"
                onClick={() => setIsUnmatchMenuOpen(!isUnmatchMenuOpen)}
              >
                <Menu
                  isOpen={isUnmatchMenuOpen}
                  setIsOpen={setIsUnmatchMenuOpen}
                  onUnmatchClick={() => setIsUnmatchModalOpen(true)}
                  onReportClick={() => setIsReportModalOpen(true)}
                />
                <img src={MenuIcon} alt="host" width={20} height={20} />
              </div>
            </div>
          )}
        </div>
        <div className="flex flex-row justify-start items-center ">
          {loading ? ( // Check if loading
            <div className="text-py-text-primary">Loading...</div> // Show loading indicator
          ) : (
            <div className="flex flex-col md:flex-row w-full ">
              <div className="flex-1 flex flex-col justify-center w-full">
                {/* White lines at top */}
                <div className="flex justify-between items-center px-6 mb-4">
                  {[...Array(userProfilePhotos)].map((_, index: number) => (
                    <div
                      key={index}
                      className={`h-1 w-1/${userProfilePhotos}  rounded-full opacity-60 mx-2 cursor-pointer  ${
                        activePhotoSlider == index
                          ? "bg-[#FFF] shadow-md"
                          : " bg-[#F1E7EC]"
                      }`}
                      onClick={() => handleUserPhotoSlider(index)}
                    />
                  ))}
                </div>
                {topBarInfoMessages && (
                  <div className="flex justify-center items-center w-full mb-2">
                    <TopStatusBar
                      status={topBarInfoMessages?.status}
                      message={topBarInfoMessages?.message}
                    />
                  </div>
                )}

                <div className="flex flex-col w-full mb-[2rem]">
                  <div className="flex-1 relative self-center flex justify-center w-full">
                    <div className="w-full h-[400px] md:w-[305px] md:h-auto">
                      <div className="w-full h-[400px] relative overflow-hidden">
                        <img
                          src={
                            disableOriginalProfile > 0 &&
                            guestDetails?.orgProfilePhoto
                              ? guestDetails?.orgProfilePhoto
                              : guestDetails?.userPhotos?.[activePhotoSlider]
                          }
                          alt="background"
                          className="object-cover w-full h-full  border-4 border-white rounded-3xl shadow-lg"
                        />
                      </div>
                    </div>

                    {userProfilePhotos &&
                      userProfilePhotos > 1 &&
                      disableOriginalProfile == 0 && (
                        <>
                          {/* Left Arrow */}
                          <button
                            onClick={() => {
                              const prevIndex =
                                (activePhotoSlider - 1 + userProfilePhotos) %
                                userProfilePhotos;
                              handleUserPhotoSlider(prevIndex);
                            }}
                            className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 p-2 rounded-full shadow"
                          >
                            <span className="text-white">
                              <img
                                src={
                                  activePhotoSlider == 0
                                    ? NextDisableIcon
                                    : NextActiveIcon
                                }
                                className="w-auto h-2 cursor-pointer transform rotate-180"
                                alt="next"
                              />
                            </span>
                          </button>

                          {/* Right Arrow */}
                          <button
                            onClick={() => {
                              const nextIndex =
                                (activePhotoSlider + 1) % userProfilePhotos;
                              handleUserPhotoSlider(nextIndex);
                            }}
                            className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 p-2 rounded-full shadow"
                          >
                            <span className="text-white">
                              <img
                                src={
                                  userProfilePhotos == activePhotoSlider + 1
                                    ? NextDisableIcon
                                    : NextActiveIcon
                                }
                                className="w-auto h-2 cursor-pointer"
                                alt="next"
                              />
                            </span>
                          </button>
                        </>
                      )}
                  </div>

                  <div className="flex flex-col justify-between items-start w-full mt-8 mb-2 pr-1">
                    <div className="w-5/6 text-left text-white text-4xl font-[PINYADA-Beranda-Regular] leading-tight-120 tracking-tight-2 flex flex-wrap">
                      <span className="line-clamp-2 break-words">
                        {disableOriginalProfile == 0
                          ? guestDetails?.firstName
                          : userObj?.hostAlias}
                      </span>
                      {guestDetails?.age && (
                        <span className="ml-1">, {guestDetails.age}</span>
                      )}
                    </div>
                    <div className="w-5/6 text-left text-white text-4xl font-[PINYADA-Beranda-Regular] leading-tight-120 tracking-tight-2 flex flex-wrap">
                      {guestDetails?.pronouns && (
                        <span className="text-3xl">
                          ({guestDetails.pronouns})
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="user-information-wrapper text-left text-[#0F090B] pr-1">
                    <div className="flex flex-row flex justify-center text-[#0F090B] ">
                      <div className="flex flex-col gap-2 w-full py-6 relative">
                        {/* User Profile Info Section both for logged & guest users */}
                        <>
                          <div className="flex flex-col gap-2 pb-2">
                            {profileVisibility.genderVisibility &&
                              guestDetails?.gender?.length > 0 && (
                                <div className="flex gap-2  bg-py-bg-secondary p-2 rounded-lg items-center">
                                  {getGenderIcon(guestDetails?.gender)}
                                  <span className="text-[#0F090B]  text-sm">
                                    {GENDERDECODE[guestDetails.gender]
                                      ? GENDERDECODE[guestDetails.gender]
                                      : guestDetails?.gender}
                                  </span>
                                </div>
                              )}
                            {profileVisibility.informationVisible &&
                              guestDetails?.job_title?.length > 0 && (
                                <div className="flex gap-2 bg-py-bg-secondary p-2 rounded-lg items-center">
                                  <img
                                    alt="under-computer--v1"
                                    src={Icons.WorkSpaceIcon}
                                    className="w-6 h-6"
                                  />

                                  <span className="text-[#0F090B]  text-sm">
                                    {guestDetails?.job_title} at{" "}
                                    {guestDetails?.workplace}
                                  </span>
                                </div>
                              )}
                            {profileVisibility.informationVisible &&
                              guestDetails?.university && (
                                <div className="flex gap-2  bg-py-bg-secondary p-2 rounded-lg items-center">
                                  <img
                                    src={Icons.UniversityIcon}
                                    alt="map--v1"
                                    className="w-6 h-6"
                                  />
                                  <span className="text-[#0F090B]  text-sm">
                                    {guestDetails?.university}
                                  </span>
                                </div>
                              )}
                            {((guestDetails?.city &&
                              guestDetails?.city?.length > 0) ||
                              (guestDetails?.country &&
                                guestDetails?.country?.length > 0)) && (
                              <div className="flex gap-2  bg-py-bg-secondary p-2 rounded-lg items-center">
                                <img
                                  src={Icons.AddressIcon}
                                  alt="map--v1"
                                  className="w-6 h-6"
                                />

                                <span className="text-[#0F090B]  text-sm">
                                  {guestDetails?.city}
                                  {guestDetails?.country && guestDetails?.city
                                    ? `, ${guestDetails.country}`
                                    : guestDetails?.country &&
                                      !guestDetails?.city
                                    ? guestDetails.country
                                    : ""}
                                </span>
                              </div>
                            )}
                            {profileVisibility.heightVisibility &&
                              guestDetails?.height &&
                              guestDetails?.height?.length > 0 && (
                                <div className="flex gap-2  bg-py-bg-secondary p-2 rounded-lg items-center">
                                  <img
                                    src={Icons.HeightIcon}
                                    alt="back"
                                    className="w-6 h-6"
                                  />
                                  <span className="text-[#0F090B]  text-sm">
                                    {guestDetails?.height}
                                  </span>
                                </div>
                              )}
                          </div>
                          <div className="">
                            {profileVisibility.lookingForVisibility &&
                              guestDetails?.interestedIns?.length > 0 && (
                                <div className="py-2">
                                  <span className="text-py-text-primary text-base">
                                    Interested in dating
                                  </span>
                                  <div className="flex flex-wrap gap-2 mt-2">
                                    {guestDetails?.interestedIns
                                      .split(",")
                                      ?.map((item: any, idx: number) => (
                                        <span
                                          key={idx}
                                          className="bg-py-bg-secondary p-2 rounded-lg text-[#0F090B]  text-sm font-semibold"
                                        >
                                          {GENDERDECODELOOKING[item]
                                            ? GENDERDECODELOOKING[item]
                                            : item}
                                        </span>
                                      ))}
                                  </div>
                                </div>
                              )}
                            {profileVisibility.meetingPurposeVisibility &&
                              guestDetails?.meetingPurpose?.length > 0 && (
                                <div className="py-2">
                                  <span className="text-py-text-primary text-base">
                                    Looking for
                                  </span>

                                  <div className="flex flex-wrap gap-2 mt-2">
                                    {guestDetails.meetingPurpose
                                      .split(",")
                                      .map((item: string) =>
                                        item.trim().toLowerCase()
                                      )
                                      .sort(
                                        (a:any, b:any) =>
                                          MEETING_PURPOSE_ORDER.indexOf(a) -
                                          MEETING_PURPOSE_ORDER.indexOf(b)
                                      )
                                      .map((item: string, idx: number) => {
                                        const formatted =
                                          item === "open to anything"
                                            ? "Open to both"
                                            : item.charAt(0).toUpperCase() +
                                              item.slice(1);

                                        return (
                                          <span
                                            key={idx}
                                            className="bg-py-bg-secondary p-2 rounded-lg text-[#0F090B] text-sm font-semibold"
                                          >
                                            {formatted}
                                          </span>
                                        );
                                      })}
                                  </div>
                                </div>
                              )}

                            {/* {profileVisibility.interestVisibility && */}
                              {guestDetails?.interests?.length > 0 && (
                                <div className="py-2">
                                  <span className="text-py-text-primary text-base">
                                    Interests
                                  </span>
                                  <div className="flex flex-wrap gap-2 mt-2">
                                    {guestDetails?.interests?.map(
                                      (item: any, idx: number) => (
                                        <span
                                          key={idx}
                                          className="bg-py-bg-secondary p-2 rounded-lg text-[#0F090B]  text-sm font-semibold"
                                        >
                                          {item}
                                        </span>
                                      )
                                    )}
                                  </div>
                                </div>
                              )}

                            {guestDetails?.promptQuestions?.length > 0 && (
                              <div className="py-2">
                                <span className="text-py-text-primary text-base">
                                  Prompts
                                </span>
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {guestDetails?.promptQuestions.map(
                                    (item: any, idx: number) => (
                                      <div
                                        className="w-full bg-py-bg-secondary p-2 rounded-lg mb-2"
                                        key={idx}
                                      >
                                        <span className="text-[#0F090B]  text-base">
                                          {item?.question}...
                                        </span>
                                        <p className="text-sm text-py-text-tertiary break-words">
                                          {item?.answer}
                                        </p>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="social-media-links flex justify-start gap-3">
                            {guestDetails?.social_link_instagram &&
                              guestDetails?.social_link_instagram?.length >
                                0 && (
                                <div className="instagram">
                                  <a
                                    href={guestDetails?.social_link_instagram}
                                    target="_blank"
                                  >
                                    <img
                                      src={Icons.Instagram}
                                      alt=""
                                      className="w-8"
                                    />
                                  </a>
                                </div>
                              )}
                            {guestDetails?.social_link_linkedin &&
                              guestDetails?.social_link_linkedin?.length >
                                0 && (
                                <div className="linkedIn">
                                  <a
                                    href={guestDetails?.social_link_linkedin}
                                    target="_blank"
                                  >
                                    <img
                                      src={Icons.LinkedIn}
                                      alt=""
                                      className="w-8"
                                    />
                                  </a>
                                </div>
                              )}
                          </div>

                          {false && isVisitedByHost && eventId && selectedUserId && (
                            <div className="py-4">
                              <span className="text-py-text-primary text-base">
                                Event Responses
                              </span>
                              <div className="mt-3">
                                <GuestAnswersView
                                  eventId={Number(eventId)}
                                  guestId={Number(selectedUserId)}
                                  isHost={true}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                  <div className="mb-6 md:mb-4 h-[10vh]" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex justify-between items-center">
        {disableOriginalProfile == 0 && reqGuestId != userId && (
          <ConnectionButton
            connectionVisibility={connectionVisibility}
            isGuestSame={isGuestSame}
            connectionExpanded={connectionExpanded}
            requestedConnectionStatus={requestedConnectionStatus}
            toggleConnectionExpanded={toggleConnectionExpanded}
            sendConnectionRequest={handleConnectionRequest}
            confirmationOption={anonymousStatus}
            handleRequestType={(evt: any) => {
              setAnonymousStatus((prev) => !prev);
            }}
            connectionReqLoader={connectionReqLoader}
            showMatchedButton={connectedStatus}
            openChatModal={() => {
              setIsChatModalOpen(true);
            }}
            eventDetailObj={eventDetailObj}
          />
        )}
      </div>

      {/* Connection Request / Matched Status Modal*/}
      {(connectionRequestStatus || connectionMatchedStatus) && (
        <RightSideDrawer
          open={connectionRequestStatus || connectionMatchedStatus}
          onClose={() => {
            setConnectionRequestStatus(false);
            if (isConnectionModalOpen) {
              setIsConnectionModalOpen(true);
            }
            // setIsConnectionModalOpen(true)
            handleRefetchGuestDetails();
          }}
          title={
            selectedDrawer == CONNECTION_REQUEST_STATUS.REQUEST_SENT
              ? CONNECTION_REQUEST_STATUS.REQUEST_SENT
              : selectedDrawer == CONNECTION_REQUEST_STATUS.REQUEST_MATCHED
              ? CONNECTION_REQUEST_STATUS.REQUEST_MATCHED
              : CONNECTION_REQUEST_STATUS.REQUEST_SENT
          }
          showTitle={
            selectedDrawer == CONNECTION_REQUEST_STATUS.REQUEST_SENT
              ? true
              : false
          }
          widthIncreased={true}
          className={
            "md:w-[65vw] lg:w-[55vw] side-drawer-connection-request-modal"
          }
        >
          {selectedDrawer == CONNECTION_REQUEST_STATUS.REQUEST_SENT ? (
            <ConnectionRequestSentWidget
              guestDetails={guestDetails}
              userDetails={userDetails}
              requestedConnectionStatus={requestedConnectionStatus}
              handleRefetchGuestDetails={() => handleRefetchGuestDetails()}
              handleChatModal={() => setIsChatModalOpen(true)}
            />
          ) : (
            <ConnectionRequestMatchedWidget
              guestDetails={guestDetails}
              userDetails={userDetails}
              requestedConnectionStatus={requestedConnectionStatus}
              handleRefetchGuestDetails={() => handleRefetchGuestDetails()}
              handleChatModal={() => setIsChatModalOpen(true)}
            />
          )}
        </RightSideDrawer>
      )}

      {isChatModalOpen && (
        <Modal showButtons={false} onOkClick={() => setIsChatModalOpen(false)}>
          <div className="w-full  text-center flex flex-col gap-4">
            <p className="text-py-text-primary text-base">
              Download the Pinyada App to chat with your connections.
            </p>

            <div className="flex justify-center py-2 gap-2 md:gap-4">
              <a
                href="https://apps.apple.com/app/id6444107828"
                className="w-[8rem] md:w-[9.5rem] hover:scale-105 transform transition-all duration-200"
              >
                <img
                  src={AppStore}
                  alt="app store "
                  className="w-[7rem] h-[2rem] md:w-[9.2rem] md:h-11"
                />
              </a>{" "}
              <a
                href="https://play.google.com/store/apps/details?id=com.app.socha"
                className="w-[8rem] md:w-[9.5rem] hover:scale-105 transform transition-all duration-200"
              >
                {" "}
                <img
                  src={PlayStore}
                  alt="Android"
                  className="w-[7rem] h-[2rem] md:w-[9.2rem] md:h-11"
                />
              </a>
            </div>
          </div>
        </Modal>
      )}
      {isUnmatchModalOpen && (
        <Modal
          onClose={() => setIsUnmatchModalOpen(false)}
          onSave={() => {
            setIsUnmatchModalOpen(false);
            unmatchUser();
          }}
          isOpen={true}
        >
          <div className="w-full  text-center flex flex-col gap-2 w-full min-h-[6rem] sm:min-h-[8rem]  rounded-lg p-3 text-sm sm:text-base text-[#0F090B] resize-none focus:outline-none focus:ring-1 focus:ring-gray-400">
            <h1 className="text-py-text-primary text-2xl font-bold font-[PINYADA-Beranda-Regular]">
              Unmatch {`${guestDetails ? `${guestDetails.firstName}` : ""}`}?
            </h1>
            <p className="text-[18px]">
              Are you sure you want to unmatch with{" "}
              {`${guestDetails ? `${guestDetails.firstName}` : ""}`}? This
              action will permanently delete all conversations with{" "}
              {`${guestDetails ? `${guestDetails.firstName}` : ""}`}
              ?.
            </p>
          </div>
        </Modal>
      )}
      {isReportModalOpen && (
        <Modal
          onClose={() => setIsReportModalOpen(false)}
          onSave={() => {
            setIsReportModalOpen(false);
            reportUser();
          }}
        >
          <div
            className="
        w-full max-w-[92vw] sm:max-w-md
        px-4 sm:px-6
        text-left text-black
      "
          >
            {/* Title */}
            <h2 className="text-base sm:text-lg font-semibold text-center mb-4">
              Report {guestDetails?.firstName || "User"}?
            </h2>

            {/* Reason select */}
            <div className="mb-4">
              <label className="block text-xs sm:text-sm font-medium mb-1">
                Reason
              </label>
              <SearchSelect
                className="
            w-full bg-white rounded-xl
            text-sm sm:text-base font-medium
          "
                options={REPORT_TYPES}
                placeholder="Select a reason"
                onChange={(e: any) => setReportType(e.value)}
              />
            </div>

            {/* Description */}
            <div className="mb-2">
              <label className="block text-xs sm:text-sm font-medium mb-1">
                Additional details
              </label>
              <textarea
                className="
            w-full min-h-[6rem] sm:min-h-[8rem]
            bg-py-bg-secondary rounded-lg
            p-3 text-sm sm:text-base
            text-[#0F090B]
            resize-none
            focus:outline-none focus:ring-1 focus:ring-gray-400
          "
                placeholder="Enter more details..."
                onChange={(e: any) => setReportDescription(e.target.value)}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default UserProfile;
